module.exports = __webpack_public_path__ + "media/stylesheets/fonts/fontawesome/fa-solid-900-f6121be597a72928f54e7ab5b95512a1.woff2";